import type { InstitutionTheme } from '../types';
import { ucmercedColors } from './colors';

// UC Merced institutional theme (W41 41.3 S3).
//
// Brand strings per the S1-verified fact sheet (admin_tools/backend/data/
// onboarding/ucmerced/fact_sheet.yaml): official university name;
// "My Registration" is the registration tile on UC Merced Connect
// (my.ucmerced.edu), Banner 9 SSB underneath. Colors per ./colors.ts
// (Bobcat Blue PMS 295 + Bobcat Gold PMS 110, S1-verified).
//
// Example course codes verified live against the Banner SSB API (S0/S1
// probes, all three directly observed): CSE 031 (Introduction to Computer
// Science — zero-padded, the format's signature), WRI 010 (College Reading
// and Composition — GE Written Communication), MATH 011 (Calculus I).
// The fact sheet's fourth example (ANTH 005H) is deliberately omitted here —
// honors sections aren't representative placeholder text. First entry is
// the primary single-example shown in placeholder text.
export const ucmercedTheme: InstitutionTheme = {
  slug: 'ucmerced',
  universityName: 'University of California, Merced',
  universityShortName: 'UC Merced',
  registrationPortalName: 'My Registration',
  exampleCourseCodes: ['CSE 031', 'WRI 010', 'MATH 011'],
  colors: ucmercedColors,
};
